import React, { useEffect, useState } from "react";
import "./Forms.scss";
import { CreateButton, GreyBackgroundButton, GreyBorderButton } from "../../../../Global/GlobalButton";
import { FormHeading, RegisterGreyHeading } from "../../../../Global/GlobalText";
import { TitleBar } from "../../../../Global/TitleBar/TitleBar";
import { RegistrationForm } from "../../../../Admin-Creating-New-Event/MyEvents/RegistrationForm/RegistrationForm";
import { toast } from "react-toastify";
import { EXCHNAGE_URL } from "../../../../../Url/Url";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import UpdateRegistrationForm from "../UpdateForm/UpdateRegistrationForm";
import UpdateNewEntryForm from "../UpdateForm/UpdateNewEntryForm";
import { resetEntryState, resetState } from "../../../../Redux/Users/action";
import { EntryForm } from "../../../../Admin-Creating-New-Event/MyEvents/EntryForm/EntryForm";
import { useLoading } from "../../../../LoadingContext";

export const Forms = () => {
  const [showFormOne, setShowFormOne] = useState(true);
  const [showFormTwo, setShowFormTwo] = useState(true);

  const [newFormSchema, setNewFormSchema] = useState([]); // Initial empty form schema
  // const [isLoading, setIsLoading] = useState(false); // Loading state for the form fetch
  const [entryFormSchema, setEntryFormSchema] = useState([]);
  const eventIdGet = useSelector((state) => state?.users?.id);
  const registrationFormId = useSelector((state) => state?.users?.registrationFormId);
  const entryFormId = useSelector((state) => state?.users?.entryFormId);

  const { setLoading } = useLoading(); 
  const [formKey, setFormKey] = useState(0);
  const dispatch = useDispatch();

  const handleRegistrationForm = async () => {
    setShowFormOne(false);
    try {
      setLoading(true);
      const response = await axios
        .get(`${EXCHNAGE_URL}/registrationForm?eventId=${eventIdGet}&registrationFormId=${registrationFormId}`, {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
      if (response.status === 200) {
        toast.success("Registration form fetched successfully")
        const fetchedFields = response.data.data.form_schema;
        const jsonArray = JSON.parse(fetchedFields);
        console.log(jsonArray, "1111")
        setNewFormSchema(jsonArray);
      } else {
        toast.error("Failed to fetch the registration form.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };
  const handleEntryForm = async () => {
    setShowFormTwo(false);
    try {
      setLoading(true);
      const response = await axios
        .get(`${EXCHNAGE_URL}/entryForm?eventId=${eventIdGet}&entryFormId=${entryFormId}`, {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
      if (response.status === 200) {
        toast.success("Entry form fetched successfully")
        const fetchedFields = response.data.data.form_schema;
        const jsonArray = JSON.parse(fetchedFields);
        console.log(jsonArray, "1111")
        setEntryFormSchema(jsonArray);
      } else {
        toast.error("Failed to fetch the Entry form.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }finally {
      setLoading(false);
  }
  };
  const handleCloseReg = () => {
    setShowFormOne(true)
    dispatch(resetState())
  }

  const handleCloseEntry = () => {
    setShowFormTwo(true)
    dispatch(resetEntryState())
  }
  console.log(entryFormSchema, "qwe")
  console.log(newFormSchema, "asdasdasasasasasasasas")

    useEffect(() => {
      return () => {
        dispatch(resetEntryState());
      };
    }, [dispatch]);

    const handleSaveSuccess = () => {
      setFormKey(prev => prev + 1); 
      handleEntryForm(); 
    };

    
  return (
    <div>
      <div className="dashboard_div">
        <TitleBar title="Forms" />
        <div className="dashboard_white_bg">
          {showFormOne && showFormTwo && (
            <>
              <div className="forms_heading">
                <FormHeading>Update Your Form</FormHeading>
              </div>

              <div className="forms_div">
                <div className="forms_sub_div_one">
                  <RegisterGreyHeading style={{ fontWeight: 500 }}>
                    Registration Form
                  </RegisterGreyHeading>
                  <div>
                    <CreateButton
                      onClick={handleRegistrationForm}
                    >
                      Customize
                    </CreateButton>
                  </div>
                </div>

                <div className="forms_sub_div_two">
                  <RegisterGreyHeading style={{ fontWeight: 500 }}>
                    Submission Form
                  </RegisterGreyHeading>
                  <div>
                    <CreateButton
                      onClick={handleEntryForm}
                    >Customize</CreateButton>
                  </div>
                </div>
              </div>
            </>
          )}
          {!showFormOne &&
            (registrationFormId ? (
              <>
                <UpdateRegistrationForm
                  regFormSchema={newFormSchema}
                  showFormOne={showFormOne}
                  setShowFormOne={setShowFormOne}
                />
                <GreyBackgroundButton
                  type="button"
                  onClick={handleCloseReg}
                  className="btn-div"
                >
                  Cancel Updation
                </GreyBackgroundButton>
              </>
            ) : (
              <>

                <RegistrationForm />

                <GreyBackgroundButton
                  type="button"
                  onClick={handleCloseReg}
                  className="btn-div"
                >
                  Cancel Updation
                </GreyBackgroundButton>
              </>
            ))}

          {!showFormTwo &&
            (entryFormId ? (
              <>
                <UpdateNewEntryForm
                  entFormSchema={entryFormSchema}
                  setShowFormTwo={setShowFormTwo}
                  onSaveSuccess={handleSaveSuccess}
                />
                <GreyBackgroundButton
                  type="button"
                  onClick={handleCloseEntry}
                  className="btn-div"
                >
                  Cancel Updation
                </GreyBackgroundButton>
              </>
            ) : (
              <>
                <EntryForm />

                <GreyBackgroundButton
                  type="button"
                  onClick={handleCloseEntry}
                  className="btn-div"
                >
                  Cancel Updation
                </GreyBackgroundButton>
              </>
            ))}
        </div>
      </div>
    </div>
  );
};
